export default __webpack_public_path__ + "static/axicube-comapny-desk-ce25a0498b013dd5855665c01be658ac.webp";